module.exports = __webpack_public_path__ + "img/95.15f08771.jpg";